
import {
editvirtualroom,
queryvirtualroomdevice,
sharevirtualroom,
queryshareroomphone,
deletesharevirtualroom,
editvirtualroomuser,
delvirtualroom, addvirtualroom, delroomdevice, addroomdevice, load2
} from '../../api/device'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

export default {
name: 'setFamilyItem',
directives: {
TransferDom
},
data () {
return {
upDown: true,
selectFamily: '',
roomNum: 0,
noHomeRoom: [], // 默认场所设备
familyList: [], // 所有场所分组
rooms: [], // 列表
editFamilyShow: false,
sendFamily: {
name: ''
},
showAdd: false,
addText: '成功',
addWarn: false,
warnText: '',
fromPath: '',
memberData: [],
addEditMemberShow: false,
sendFamilyMember: {
name: '',
phone: ''
},
memberShow: false,
isSureDel: false,
memberSelect: '',
deviceData: [], // 全部设备
unbindDevice: [], // 场所未绑定设备
imgArr: [],

titleNameRoom: '',
editRoomShow: false,
roomSelect: {},
idx: '',
hotName2: [{name: '客厅'}, {name: '主卧'}, {name: '次卧'}, {name: '房间'}, {name: '卫生间'}, {name: '厨房'}, {name: '大门'}],
selectHot2: '',
sendRoom: {
isAdd: true,
name: ''
},

roomSelectObj: '',
delRoomShow: false,

bindShow: false,
selectRoomBind: '',
selectDevices: [],

unbindShow: false,
selectRoomUnbind: '',
selectRoomDevice: ''
}
},
created () {
document.getElementsByTagName('title')[0].innerText = '设置场所'
this.imgArr = this.common.getDeviceImg()
this.selectFamily = this.$store.getters.get_family_obj
this.getAllDeviceData()

this.queryFamilyList() 
},
mounted () {
document.getElementsByTagName('title')[0].innerText = '设置场所'
},
beforeDestroy () {
document.getElementsByTagName('title')[0].innerText = '智慧安防'
},
beforeRouteEnter (to, from, next) {
next(vm => {

vm.fromPath = from.path
})
},
methods: {

getAllDeviceData () {
this.unbindDevice = []
load2().then(res => {
let arr = res.data && res.data.devices !== null ? res.data.devices : []
this.deviceData = arr

for (let i = 0; i < arr.length; i++) { // 解决默认家庭的设备
if (arr[i].areaid === 0 && arr[i].roomid === 0) {
let obj = {
did: arr[i].id,
name: '未分组',
deviceObj: arr[i]
}
this.noHomeRoom.push(obj)
}
}
this.getAllHomeDevice()
}).catch(() => {})
},
getImageUrl (dtype) {
let key = parseInt(dtype)
let imgdata = this.imgArr
let img = imgdata[this.imgArr.length - 1].imgUrl
for (let i = 0; i < imgdata.length; i++) {
if (imgdata[i].dtype === key) {
img = imgdata[i].imgUrl
}
}
return img
},

queryFamilyList () {
let data = {
roomid: [this.selectFamily.id]
}
queryshareroomphone(data).then(res => {
if (res.code === 200) {

if (res.data && res.data.length > 0) {
this.memberData = res.data
} else {
this.memberData = []
}
} else {
this.addWarn = true
this.warnText = res.msg
}
}).catch(() => {})
},

addMemberOpen () {
this.sendFamilyMember.name = ''
this.sendFamilyMember.phone = ''
this.addEditMemberShow = true
},
addShareRoomPerson () {
let data = {
name: this.sendFamilyMember.name,
phone: this.sendFamilyMember.phone,
roomid: this.selectFamily.id,
role: 'share'
}
sharevirtualroom(data).then(res => {
if (res.code === 200) {
this.queryFamilyList()
this.showAdd = true
this.addText = '成功'
this.addEditMemberShow = false
} else {
this.addWarn = true
this.warnText = res.msg
}
}).catch(() => {})
},

memberOpen (item) {
this.memberSelect = this.clone(item)
this.memberShow = true
this.isSureDel = false
},
editFamilyMember () {
console.log(this.memberSelect, this.selectFamily)
let body = {
roomid: this.memberSelect.roomid,
phone: this.memberSelect.phone,
name: this.memberSelect.name
}
editvirtualroomuser(body).then(res => {
if (res.code === 200) {
this.queryFamilyList()
this.showAdd = true
this.addText = '成功'
this.memberShow = false
} else {
this.addWarn = true
this.warnText = res.msg
}
}).catch(() => {})
},

delFamilyMember () {
let data = {
phone: this.memberSelect.phone,
roomid: this.memberSelect.roomid,
role: this.memberSelect.role
}
deletesharevirtualroom(data).then(res => {
if (res.code === 200) {
this.queryFamilyList()
this.showAdd = true
this.addText = '成功'
this.memberShow = false
} else {
this.addWarn = true
this.warnText = res.msg
}
}).catch(() => {})
},
getAllHomeDevice () {
this.familyList = []
this.rooms = []
queryvirtualroomdevice().then(res => {
if (res.code === 200) {
if (res.data && res.data.length > 0) {
this.familyList = res.data
} else {
this.familyList = []
}
let arr = []
for (let i = 0; i < this.familyList.length; i++) {
if (this.selectFamily.id === this.familyList[i].parentid) {
arr.push(this.familyList[i])
} else if (this.selectFamily.id === this.familyList[i].id) { // 绑定场所的设备（未分组设备）
if (this.familyList[i].devices !== null && this.familyList[i].devices.length > 0) {
arr.push(this.familyList[i])
}
}
}

for (let i = 0; i < arr.length; i++) {
let item = arr[i]
item.upDownShow = true
let deviceArr = []
let devices = arr[i].devices !== null ? arr[i].devices : []
for (let j = 0; j < devices.length; j++) {
if (this.selectFamily.id === arr[i].id) {

if (devices[j].areaid !== 0 && devices[j].roomid === 0) {
devices[j].deviceObj = this.getDeviceObj(devices[j].did)
deviceArr.push(devices[j])
}
} else {

devices[j].deviceObj = this.getDeviceObj(devices[j].did)
deviceArr.push(devices[j])
}
}
item.devices = deviceArr
if (item.id === this.selectFamily.id) {
if (item.devices.length > 0 && item.devices !== null) {
this.rooms.push(item)
}
} else {
this.rooms.push(item)
}

}
this.roomNum = this.rooms.length
}
}).catch(() => {})
},
getDeviceObj (did) {

let obj = ''
for (let i = 0; i < this.deviceData.length; i++) {
if (did === this.deviceData[i].id) {
obj = this.deviceData[i]
}
}
return obj
},
editHomeOpen () {
if (this.selectFamily.role !== 'owner') {
return
}
this.sendFamily.name = this.selectFamily.name
this.editFamilyShow = true
},
editHome () {
if (this.sendFamily.name === '') {
return
}
let data = {
name: this.sendFamily.name,
roomid: this.selectFamily.id
}
editvirtualroom(data).then(res => {
if (res.code === 200) {
this.showAdd = true
this.addText = '成功'
this.editFamilyShow = false
this.selectFamily.name = data.name
} else {
this.addWarn = true
this.warnText = res.msg
}
}).catch(() => {})
},
addEditRoomSend () {
if (this.sendRoom.isAdd) {
this.addRoomSend()
} else {
this.editRoomSend()
}
},

addFamilyRoomOpen () {
this.sendRoom.isAdd = true
this.titleNameRoom = '新建分组'
this.sendRoom.name = ''
this.editRoomShow = true
},
selectHotName2 (item) {
if (this.selectHot2 !== item.name) {
this.selectHot2 = item.name
this.sendRoom.name = this.selectHot2
} else {
this.selectHot2 = ''
this.sendRoom.name = ''
}
},
addRoomSend () {
let data = {
name: this.sendRoom.name,
level: 2,
parentid: this.selectFamily.id
}
addvirtualroom(data).then(res => {
if (res.code === 200) {
this.getAllHomeDevice()
this.showAdd = true
this.addText = '成功'
this.editRoomShow = false
} else {
this.addWarn = true
this.warnText = res.msg
}
}).catch(() => {})
},

editFamilyRoomOpen (room, idx) {

this.sendRoom.isAdd = false
this.titleNameRoom = '分组名称'
this.roomSelect = room
this.idx = idx
this.sendRoom.name = room.name
this.editRoomShow = true
},
editRoomSend () {
let data = {
name: this.sendRoom.name,
roomid: this.roomSelect.id
}
editvirtualroom(data).then(res => {
if (res.code === 200) {
this.showAdd = true
this.addText = '成功'
this.editRoomShow = false
this.rooms[this.idx].name = data.name
} else {
this.addWarn = true
this.warnText = res.msg
}
}).catch(() => {})
},

delRoomOpen (room) {
this.roomSelectObj = room
this.delRoomShow = true
},
delSelectRoom () {
let data = {
roomid: this.roomSelectObj.id
}
delvirtualroom(data).then(res => {
if (res.code === 200) {
for (let i = 0; i < this.rooms.length; i++) {
if (data.roomid === this.rooms[i].id) {
this.rooms.remove(this.rooms[i])
}
}
this.showAdd = true
this.addText = '成功'
this.delRoomShow = false
} else {
this.addWarn = true
this.warnText = res.msg
}
}).catch(() => {})
},

getSetUpDown (index) {
this.upDown = !this.upDown
for (let i = 0; i < this.rooms.length; i++) {
if (this.upDown) {
this.rooms[i].upDownShow = true
} else {
this.rooms[i].upDownShow = false
}
}

this.$forceUpdate()
},
getUpDown (idx) {
this.rooms[idx].upDownShow = !this.rooms[idx].upDownShow
this.$forceUpdate()
},
getRoomNameShow (item) {
let name = ''
if (item.areaid === 0 && item.roomid === 0) { // 默认分组
name = '默认场所'
} else if (item.areaid !== 0 && item.roomid === 0) { // 属于场所
for (let i = 0; i < this.familyList.length; i++) {
if (item.areaid === this.familyList[i].id) {
name = this.familyList[i].name
}
}
} else if (item.areaid !== 0 && item.roomid !== 0) { // 属于分组
for (let i = 0; i < this.familyList.length; i++) {
if (item.roomid === this.familyList[i].id) {
name = this.familyList[i].name
}
}
} else {
name = '未定义'
}
return name
},

addDeviceOpen (room) {
this.unbindDevice = []
let arr = []
for (let i = 0; i < this.deviceData.length; i++) {
let obj = this.deviceData[i]
obj.isSelect = false
if (this.deviceData[i].phonedevicerole === 'normal' || this.deviceData[i].phonedevicerole === '') { // 过滤分享设备
} else {
if (this.deviceData[i].areaid === 0 && this.deviceData[i].roomid === 0) { // 默认场所
arr.push(obj)
} else {
if (this.deviceData[i].areaid === this.selectFamily.id) { // 筛选出当前场所的设备
if (this.deviceData[i].roomid !== room.id) { // 过滤当前分组的设备
arr.push(obj)
}
}
}
}
}
this.unbindDevice = arr

this.selectRoomBind = room
this.selectDevices = []
this.bindShow = true
},
selectBindDevice (item, idx) {
if (item.isSelect) {
let arr = []
for (let i = 0; i < this.selectDevices.length; i++) {
if (item.did !== this.selectDevices[i].did) {
arr.push(this.selectDevices[i])
}
}
this.selectDevices = arr
this.unbindDevice[idx].isSelect = false
} else {
this.selectDevices.push(item)
this.unbindDevice[idx].isSelect = true
}


},
bindDeviceSend () {
let dids = []
for (let i = 0; i < this.selectDevices.length; i++) {
dids.push(this.selectDevices[i].id)
}
if (dids.length === 0) {
return
}
let data = {


level: 2,
roomid: this.selectRoomBind.id,
dids: dids
}
addroomdevice(data).then(res => {
if (res.code === 200) {
this.getAllDeviceData()
this.showAdd = true
this.addText = '成功'
this.bindShow = false
} else {
this.addWarn = true
this.warnText = res.msg
}
}).catch(() => {})
},

unbindDeviceOpen (device, room) {

this.selectRoomDevice = device
this.selectRoomUnbind = room
this.unbindShow = true
},
unbindRoomDeviceSend () {
let data = {
roomid: this.selectRoomDevice.roomid,
dids: [this.selectRoomDevice.deviceObj.id]
}
delroomdevice(data).then(res => {
if (res.code === 200) {
this.getAllDeviceData()
this.showAdd = true
this.addText = '成功'
this.unbindShow = false
} else {
this.addWarn = true
this.warnText = res.msg
}
}).catch(() => {})
}
}
}



// WEBPACK FOOTER //
// ./src/components/more/setFamilyItem.vue